module.exports = __webpack_public_path__ + "img/fission-circle.f649f7cf.png";